import { useState } from 'react';
import { Mail, FileText, Folder, PaperclipIcon, Home, Users, Briefcase, Phone, Menu, X, Code, Rocket, Settings } from 'lucide-react';
import ContactPage from './components/ContactUs';
import HomePage from './components/Home';
import AboutPage from './components/About';
import ServicesPage from './components/Services';
// Main App Component
export default function App() {
  const [activePage, setActivePage] = useState('home');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const renderPage = () => {
    switch (activePage) {
      case 'home':
        return <HomePage setActivePage={setActivePage} />;
      case 'about':
        return <AboutPage />;
      case 'services':
        return <ServicesPage />;
      case 'contact':
        return <ContactPage />;
      default:
        return <HomePage />;
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Navigation */}
      <header className="bg-amber-100 shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center space-x-1 ml-10">
              {/* <div className="bg-amber-500 p-2 rounded-md"> */}
              {/* <Mail className="text-gray-800" size={24} /> */}
              {/* </div> */}
              <h1 className="text-4xl font-bold text-gray-10
              
              00">Techapplics</h1>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex space-x-8">
              <NavLink
                active={activePage === 'home'}
                onClick={() => setActivePage('home')}
                icon={<Home size={18} />}
                text="Home"
              />
              <NavLink
                active={activePage === 'about'}
                onClick={() => setActivePage('about')}
                icon={<Users size={18} />}
                text="About Us"
              />
              <NavLink
                active={activePage === 'services'}
                onClick={() => setActivePage('services')}
                icon={<Briefcase size={18} />}
                text="Services"
              />
              <NavLink
                active={activePage === 'contact'}
                onClick={() => setActivePage('contact')}
                icon={<Phone size={18} />}
                text="Contact Us"
              />
            </nav>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="p-2 rounded-md text-gray-700 hover:bg-amber-200"
              >
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-amber-50 pb-4">
            <div className="container mx-auto px-4 flex flex-col space-y-2">
              <MobileNavLink
                active={activePage === 'home'}
                onClick={() => {
                  setActivePage('home');
                  setMobileMenuOpen(false);
                }}
                icon={<Home size={18} />}
                text="Home"
              />
              <MobileNavLink
                active={activePage === 'about'}
                onClick={() => {
                  setActivePage('about');
                  setMobileMenuOpen(false);
                }}
                icon={<Users size={18} />}
                text="About Us"
              />
              <MobileNavLink
                active={activePage === 'services'}
                onClick={() => {
                  setActivePage('services');
                  setMobileMenuOpen(false);
                }}
                icon={<Briefcase size={18} />}
                text="Services"
              />
              <MobileNavLink
                active={activePage === 'contact'}
                onClick={() => {
                  setActivePage('contact');
                  setMobileMenuOpen(false);
                }}
                icon={<Phone size={18} />}
                text="Contact Us"
              />
            </div>
          </div>
        )}
      </header>

      {/* Main Content */}
      <main className="flex-grow">
        {renderPage()}
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4">Techapplics</h3>
              <p className="text-gray-300">Your partner in tech recruitment and software development.</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><a href="#" onClick={() => setActivePage('home')} className="text-gray-300 hover:text-amber-200">Home</a></li>
                <li><a href="#" onClick={() => setActivePage('about')} className="text-gray-300 hover:text-amber-200">About Us</a></li>
                <li><a href="#" onClick={() => setActivePage('services')} className="text-gray-300 hover:text-amber-200">Services</a></li>
                <li><a href="#" onClick={() => setActivePage('contact')} className="text-gray-300 hover:text-amber-200">Contact Us</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-4">Contact</h3>
              <address className="not-italic text-gray-300">
                <p>14/3, Whitefield main road</p>
                <p>Katamnallur, Bangalore`</p>
                <p>info@techapplics.com</p>
                <p>973895</p>
              </address>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-6 text-center text-gray-400">
            <p>&copy; 2025 Techapplics. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

// Navigation Link Component
const NavLink = ({ active, onClick, icon, text }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center space-x-1 px-3 py-2 rounded-md transition-colors ${active
        ? 'bg-amber-200 text-gray-800 font-medium'
        : 'text-gray-600 hover:bg-amber-200/50'
        }`}
    >
      {icon}
      <span>{text}</span>
    </button>
  );
};

// Mobile Navigation Link Component
const MobileNavLink = ({ active, onClick, icon, text }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center space-x-2 w-full px-4 py-3 rounded-md transition-colors ${active
        ? 'bg-amber-200 text-gray-800 font-medium'
        : 'text-gray-600 hover:bg-amber-200/50'
        }`}
    >
      {icon}
      <span>{text}</span>
    </button>
  );
};









